// extracted by mini-css-extract-plugin
export var statItem = "_j2-1";
export var statsRow = "_j2-0";